<div class="isotope-container row grid-space-10">
    <div class="cssload-speeding-wheel"></div>
</div>